export enum CalendarViewType {
  // Deprecated: 月表示
  Month = 1,
  // 週表示
  Week = 2,
  // Deprecated: カレンダー表示
  CalendarWeekLegacy = 3,
  // Deprecated: 月＋時間（塗り）
  TwoColumnMonthAccent = 4,
  // 月＋時間（デフォルト）
  TwoColumnMonth = 5,
  // リスト型1
  ListTime = 6,
  // リスト型2
  GridTime = 7,
  // カレンダー表示
  WeekCalendar = 8,
}

export const MaxCalendarViewableTypeCount = 3;

export const isCalendarViewType = (viewType: CalendarViewType) => {
  return [
    CalendarViewType.WeekCalendar,
    CalendarViewType.CalendarWeekLegacy,
  ].includes(viewType);
};

export const isWeeklyViewType = (viewType: CalendarViewType) => {
  return (
    isCalendarViewType(viewType) || [CalendarViewType.Week].includes(viewType)
  );
};

export const isListViewType = (viewType: CalendarViewType) => {
  return [CalendarViewType.ListTime, CalendarViewType.GridTime].includes(
    viewType,
  );
};
